import { Placeholder } from 'react-bootstrap'
import React from 'react'

export const ActivityPlaceholder = () => {
  return (
    <div>
      <Placeholder animation="glow" as="h2">
        <Placeholder md={9} bg="primary" />
        <Placeholder md={8} />
      </Placeholder>

      <Placeholder animation="glow" as="small">
        <Placeholder md={8} bg="primary" />
        <Placeholder md={9} />
        <Placeholder md={4} />
        <Placeholder md={12} />
        <Placeholder md={8} bg="primary" />
        <Placeholder md={9} />
        <Placeholder md={4} />
        <Placeholder md={12} />
        <Placeholder md={12} />
        <Placeholder md={9} />
        <Placeholder md={12} bg="primary" />
        <Placeholder md={2} bg="primary" />
      </Placeholder>
    </div>
  )
}
